import type { DrawerConfig } from '@/features/drawer/types/DrawerConfig';
import type { Theme } from '@mui/material';
import { ContactsDrawerParams } from '@/features/drawer/components/ContactsDrawer/enums/ContactsDrawerParams';
import { DRAWER_INDEX } from '@/features/drawer/constants/drawerIndex';
import { DrawerAnchor } from '@/features/drawer/enums/DrawerAnchor';
import { DrawerSize } from '@/features/drawer/enums/DrawerSize';
import { Drawers } from '@/features/drawer/enums/Drawers';
import { defaultTheme } from '@/styles/theme/defaultTheme/defaultTheme';

export const ContactsDrawerConfig: DrawerConfig = {
  theme: defaultTheme as Theme,
  anchor: DrawerAnchor.Right,
  size: DrawerSize.Normal,
  behavior: {
    isHeaderOffsetEnabled: true,
  },
  offsets: {
    right: DrawerSize.ExtraSmall,
  },
  styles: {
    common: {
      zIndex: DRAWER_INDEX + 1,
      background: defaultTheme.palette?.background?.secondary,
    },
  },
  router: {
    allowedRoutes: ['/claim-set/'],
    drawerParam: Drawers.Contacts,
    drawerExtraParamsPrefix: Drawers.Contacts,
    drawerExtraParams: [
      ContactsDrawerParams.ContactHolderName,
      ContactsDrawerParams.ContactHolder,
      ContactsDrawerParams.ContactHolderId,
      ContactsDrawerParams.ClaimSetNumber,
      ContactsDrawerParams.ReporterId,
      ContactsDrawerParams.Highlight,
      ContactsDrawerParams.ClaimSetId,
      ContactsDrawerParams.Claim,
      ContactsDrawerParams.Policy,
      ContactsDrawerParams.Coverage,
      ContactsDrawerParams.Beneficiary,
      ContactsDrawerParams.HasBackButton,
      ContactsDrawerParams.BackButtonDestination,
    ],
  },
};
